import PrivateRoomDetails from "./PrivateRoomDetails";

export default PrivateRoomDetails;
